import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

/** The ⌘K "Add …" actions link to `?add=1`: run `open` once for it and drop the parameter. */
export function useOpenOnAddParam(open: () => void) {
  const [params, setParams] = useSearchParams();
  const wanted = params.get("add") === "1";

  useEffect(() => {
    if (!wanted) return;
    open();
    setParams(
      (prev) => {
        prev.delete("add");

        return prev;
      },
      { replace: true },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once per navigation with the parameter
  }, [wanted]);
}
